import SquareCheck from './SquareCheck'

export default SquareCheck
